import React, { useEffect } from "react";
import { useSpecialFunctions } from "../../functions";

const RaceTicketsTable = ({
  pastPostTicketsByDate,
  setTicketInfo,
  setSelectedTicketsVoidScore,
  raceIdSelected,
  setRaceIdSelected,
}) => {
  const { getTimeInfo } = useSpecialFunctions();
  useEffect(() => {
    if (pastPostTicketsByDate.length > 0) {
      // Filter the new data to obtain the information for the selected race.
      const updatedRace = pastPostTicketsByDate.filter(
        (tickets) => tickets.RaceID === parseInt(raceIdSelected),
      )[0];

      // Update the “ticketInfo” status with the new data for the selected race.
      if (
        updatedRace &&
        updatedRace.PastPostList &&
        updatedRace.PastPostList.length > 0
      ) {
        setTicketInfo(updatedRace, {
          PastPostList: updatedRace.PastPostList,
        });
      }
    }
  }, [pastPostTicketsByDate]);

  // Headers
  let headers,
    tableRaces = [];
  headers = (
    <tr className="text-center">
      <th hidden>IDRace</th>
      <th>Race</th>
      <th>Off Time</th>
    </tr>
  );

  // This function is called when the user clicks on the button View Associated Profiles
  const viewTicketsInfo = (raceID, race) => {
    setRaceIdSelected(raceID);
    setTicketInfo(race, { PastPostList: race.PastPostList });

    setSelectedTicketsVoidScore([]);
  };

  // The main Race table
  if (pastPostTicketsByDate) {
    tableRaces = pastPostTicketsByDate.map((item, i) => {
      return (
        <React.Fragment key={i}>
          <tr
            key={item.RaceID}
            style={{ cursor: "pointer" }}
            onClick={(e) =>
              viewTicketsInfo(
                item.RaceID,
                pastPostTicketsByDate.filter(
                  (tickets) => tickets.RaceID === item.RaceID,
                )[0],
              )
            }
            className={raceIdSelected === item.RaceID ? "shadedRow" : ""}
          >
            <td key={"RaceID" + i} className="d-none">
              {item.RaceID}
            </td>
            {/* Race Name */}
            <td
              key={"RaceDescription" + i}
              style={{
                verticalAlign: "middle",
                textAlign: "center",
              }}
            >
              {item.RaceDescription}
            </td>
            {/* Off Time */}
            <td
              key={"OffT" + i}
              style={{
                verticalAlign: "middle",
                textAlign: "center",
              }}
            >
              {getTimeInfo(item.OffTime)}
            </td>
          </tr>
        </React.Fragment>
      );
    });
  }

  return (
    <div
      style={{
        overflow: "auto",
      }}
      className="tablesPastPost"
    >
      <table
        className="table table-hover table-sm"
        style={{ marginTop: "21px" }}
      >
        <thead style={{ position: "sticky", top: "0", background: "#d9d9d9" }}>
          {headers}
        </thead>
        <tbody className="table-lg">{tableRaces}</tbody>
      </table>
    </div>
  );
};

export default RaceTicketsTable;
